import controller from './vd-carousel.controller'
import template from './vd-carousel.html'

/**
 * Component that allows cycling through multiple "frames" of similar content.
 *
 * Usage:
 * <vd-carousel>
 *   <vd-carousel-frame>Frame content 1</vd-carousel-frame>
 *   <vd-carousel-frame>Frame content 2</vd-carousel-frame>
 *   <vd-carousel-frame>Frame content 3</vd-carousel-frame>
 * </vd-carousel>
 */
export default {
  bindings: {
    /**
     * The index of the frame to display on initial render.
     *
     * @property initialFrame
     * @type {Number}
     */
    initialFrame: '@',
  },
  controller,
  template,
  transclude: true,
}
